import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import ViewSentNotification from "../../components/Notification/ViewSentNotification";


const ViewSendNotification = () => {
  return (
    <>

      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb id="title" title2="Notification" link2="/notification" title="View Notification" />

        <ViewSentNotification />
      </MasterLayout>

    </>
  );
};

export default ViewSendNotification; 
